import classNames from "classnames";
import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { OptionOriginal } from "PFTypes/options";

import { ListItemComponentProps } from "./list_item";
import css from "./list_item.module.scss";

export const ListItemSingle = <T extends OptionOriginal = OptionOriginal>({
  option,
  selected,
  clipOptionsOverflow
}: ListItemComponentProps<T>) => {
  const displayValue = option.displayElement ?? option.value;
  return (
    <Inline alignItems="start" className={css.listComponent}>
      <Icon name="check" size="sm" className={classNames(css.icon, { [css.iconHidden]: !selected })} />
      {typeof displayValue === "string" ? (
        <Typography variant="bodyRegular" textOverflow={clipOptionsOverflow && "clip"}>
          {displayValue}
        </Typography>
      ) : (
        displayValue
      )}
    </Inline>
  );
};
